import { Box, BoxProps } from "@chakra-ui/react";
import { forwardRef, useId } from "react";

interface ImageSkeletonProps extends BoxProps {
  borderRadius?: BoxProps["borderRadius"];
}

/**
 * A skeleton placeholder for images with gradient.
 * Uses charcoal.700 as base, gradient to lighter shade.
 */
export const ImageSkeleton = forwardRef<HTMLDivElement, ImageSkeletonProps>(
  ({ borderRadius = 10, ...props }, ref) => {
    const gradientId = useId();

    return (
      <Box ref={ref} overflow="hidden" borderRadius={borderRadius} {...props}>
        <svg width="100%" height="100%" preserveAspectRatio="none">
          <defs>
            <linearGradient id={gradientId} gradientTransform="rotate(20)">
              <stop offset="5%" stopColor="var(--chakra-colors-charcoal-700)" />
              <stop offset="95%" stopColor="#1A1B1C" />
            </linearGradient>
          </defs>
          <rect width="100%" height="100%" fill={`url(#${gradientId})`} />
        </svg>
      </Box>
    );
  },
);

ImageSkeleton.displayName = "ImageSkeleton";
